// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__10Sxb","title":"About_title__2GOJw","imgContainer":"About_imgContainer__1C4t-","content":"About_content__L3iCd","button":"About_button__1YiER"};